import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { 
  Shield, LayoutDashboard, ShieldAlert, ScrollText, Users, Server, 
  Settings, LogOut, CreditCard, Activity, Wifi, Loader2, Check, Zap, Crown, XCircle, BrainCircuit 
} from 'lucide-react';
import logo from '../img/image-2026-05-21-08-52-40-636.png';

const SubscriptionPage = ({ onLogout }) => {
  const navigate = useNavigate();
  const [data, setData] = useState({ agents_online: 0, plan_name: 'FREE', max_servers: 3, subscription_status: 'active', uptime: '0h 0m' });
  const [loading, setLoading] = useState(false);

  const userRole = localStorage.getItem('role');
  const tenantId = localStorage.getItem('tenant_id');
  const token = localStorage.getItem('token');
  const config = { headers: { 'X-NOC-Token': token } };
  const [billingInfo, setBillingInfo] = useState(null);


  const plans = [
    { 
      id: 'FREE', 
      name: 'FREE', 
      price: '0', 
      tag: 'EARLY ACCESS',
      features: ['All core features', '3 servers limit', '1,000,000 AI Analysis tokens', 'Early adopter access'],
      icon: <Shield className="text-secondary" size={24}/> 
    },
    { 
      id: 'BASIC', 
      name: 'BASIC', 
      price: '10', 
      features: ['Up to 20 servers', '1,000,000 AI Analysis tokens', 'Perfect for small teams', 'Full monitoring', 'AI alerts', 'Weekly reports'],
      icon: <Zap className="text-info" size={24}/> 
    },
    { 
      id: 'MIDDLE', 
      name: 'MIDDLE', 
      price: '20', 
      tag: 'MOST POPULAR',
      features: ['Up to 100 servers', '5,000,000 AI Analysis tokens', 'For growing infrastructure', 'Everything in Basic', 'Priority processing', 'Advanced insights'],
      icon: <Activity className="text-info" size={24}/> 
    },
    { 
      id: 'MAX', 
      name: 'MAX', 
      price: '50', 
      features: ['100+ servers', '25,000,000 AI Analysis tokens', 'Enterprise-scale monitoring', 'Everything in Middle', 'High-scale infrastructure support', 'Priority alerts'],
      icon: <Crown className="text-warning" size={24}/> 
    }
  ];

  const refresh = async () => {
    try {
      const res = await axios.get('https://ai-noc.skynix.co/api/stats', config);
      setData(res.data);
      const billRes = await axios.get('https://ai-noc.skynix.co/api/billing/status', config);
      setBillingInfo(billRes.data);
    } catch (e) { if (e.response?.status === 401) onLogout(); }
  };

  useEffect(() => { refresh(); }, []);

  const handlePlanChange = async (planId) => {
    if (planId === data.plan_name) return;
    setLoading(true);
    try {
      const res = await axios.post('https://ai-noc.skynix.co/api/subscription/create-checkout', { plan: planId }, config);
      window.location.href = res.data.url; 
    } catch (e) {
      alert("Billing service unavailable. Please try again later.");
    } finally { setLoading(false); }
  };

  const handleCancelSubscription = async () => {
  if (!window.confirm("WARNING: If you cancel, your monitoring will be DISABLED immediately. Continue?")) {
    return;
  }

  setLoading(true);
  try {
    const token = localStorage.getItem('token');

    await axios.post('https://ai-noc.skynix.co/api/subscription/cancel', {}, {
      headers: { 'X-NOC-Token': token }
    });
    
    alert("Subscription canceled. You will be logged out.");
    
    localStorage.clear(); 
    onLogout(); 
    navigate('/'); 
    
  } catch (e) {
    alert("Error: " + (e.response?.data?.detail || "Could not cancel subscription"));
  } finally {
    setLoading(false);
  }
};

  return (
    <div className="d-flex" style={{ minHeight: '100vh', backgroundColor: '#0b0e14', color: '#e2e8f0' }}>
      
     <div className="sidebar" style={{ width: '64px', background: '#0d1117', borderRight: '1px solid #1e293b', height: '100vh', position: 'fixed', display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '25px 0', zIndex: 1050 }}>
             <div
                       className="sidebar-item d-flex justify-content-center"
                       data-label="Go to Landing Page" 
                       onClick={() => window.location.href = 'https://noc.skynix.co'}
                       style={{
                         transform: 'translateY(-6px)',
                         marginBottom: '20px',
                         cursor: 'pointer' 
                       }}
                     >
                       <img
                         src={logo}
                         alt="SKYNIX"
                         style={{
                           width: '34px',
                           height: '34px',
                           objectFit: 'contain'
                         }}
                       />
                     </div>
        <div className="sidebar-item" data-label="Dashboard" onClick={() => navigate('/')} style={{ color: '#94a3b8', cursor: 'pointer', marginBottom: '30px' }}><LayoutDashboard size={24} /></div>
        <div className="sidebar-item" data-label="Security Incidents" onClick={() => navigate('/incidents')} style={{ color: '#94a3b8', cursor: 'pointer', marginBottom: '30px' }}><ShieldAlert size={24} /></div>
        <div className="sidebar-item" data-label="System Logs"  onClick={() => navigate('/logs')} style={{ color: '#94a3b8', cursor: 'pointer', marginBottom: '30px' }}><ScrollText size={24} /></div>
        <div className="sidebar-item" data-label="Infrastructure" onClick={() => navigate('/infrastructure')} style={{ color: '#94a3b8', cursor: 'pointer', marginBottom: '30px' }}><Server size={24} /></div>
        
        <div className="sidebar-item" data-label="User Management"  onClick={() => navigate('/users')} style={{ color: '#94a3b8', cursor: 'pointer', marginBottom: '30px' }}><Users size={24} /></div>
     
        <div className="sidebar-item active" data-label="Billing & Plans"  style={{ background: 'rgba(0, 242, 255, 0.1)', color: '#00f2ff', padding: '10px', borderRadius: '8px', marginBottom: '30px' }}><CreditCard size={24} /></div>
        <div className="sidebar-item mt-auto mb-3"  data-label="Settings" onClick={() => navigate('/settings')} style={{ color: '#94a3b8', cursor: 'pointer', marginBottom: '20px' }}><Settings size={24} /></div>
        <div className="sidebar-item mb-3"  data-label="Logout" onClick={onLogout} style={{cursor: 'pointer'}}><LogOut size={24} className="text-danger" /></div>
      </div>

      <div className="main-wrapper" style={{ marginLeft: '64px', width: 'calc(100% - 64px)' }}>
                   
                   
                   <header className="soc-header" style={{ height: '60px', borderBottom: '1px solid #1e293b', display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 24px', background: '#0b0e14' }}>
                     <div className="d-flex align-items-center gap-3">
                 
                      <h5 
                        className="sidebar-item tooltip-bottom m-0 d-flex align-items-center"
                        data-label="Go to Landing Page"
                        onClick={() => window.location.href = 'https://noc.skynix.co'}
                        style={{ 
                          color: '#00f2ff', 
                          fontSize: '1.1rem', 
                          cursor: 'pointer',
                          lineHeight: '1',      
                          transform: 'translateY(1px)' 
                        }}
                      >
                        SKYNIX <span className="text-white ms-2">AI-NOC</span>
                      </h5>
                       <div style={{ width: '1px', height: '24px', background: '#334155' }}></div>
                       <div className="text-secondary small d-flex align-items-center gap-2" style={{ fontSize: '0.9rem', fontWeight: '500', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                         <Activity size={16} className="text-info" /> Security Operations Center
                       </div>
                     </div>
                     
                     <div className="d-flex gap-4 align-items-center">
                      <div style={{ 
                                                     background: data.subscription_status === 'active' 
                                                       ? 'rgba(0, 242, 255, 0.1)' 
                                                       : data.subscription_status === 'loading' 
                                                         ? 'rgba(148, 163, 184, 0.1)' 
                                                         : 'rgba(239, 68, 68, 0.1)',  
                                                     
                                                     color: data.subscription_status === 'active' 
                                                       ? '#00f2ff' 
                                                       : data.subscription_status === 'loading' 
                                                         ? '#94a3b8' 
                                                         : '#ef4444', 
                                                     
                                                     padding: '4px 14px', 
                                                     borderRadius: '20px', 
                                                     fontSize: '0.8rem', 
                                                     border: `1px solid ${
                                                       data.subscription_status === 'active' 
                                                         ? '#00f2ff44' 
                                                         : data.subscription_status === 'loading' 
                                                           ? '#94a3b844' 
                                                           : '#ef444444'
                                                     }`, 
                                                     fontWeight: '600' 
                                                   }}>
                                                     {data.subscription_status === 'loading' 
                                                       ? 'Verifying license...' 
                                                       : data.subscription_status === 'active'
                                                         ? `Plan: ${data.plan_name} (${data.agents_online}/${data.max_servers})`
                                                         : 'SUBSCRIPTION INACTIVE'
                                                     }
                                                   </div>
                                                   <div className="header-metric small text-secondary">
                                                 <BrainCircuit size={14} className="me-1" style={{ color: '#a855f7' }}/> AI Tokens: <b className={data.ai_tokens_spent >= data.ai_tokens_limit ? "text-danger" : "text-white"}>
                                                     {data.ai_tokens_spent?.toLocaleString() || 0} / {data.ai_tokens_limit?.toLocaleString() || '1,000,000'}
                                                 </b>
                                               </div>
                       <div style={{ background: 'rgba(16,185,129,0.1)', color: '#10b981', padding: '4px 14px', borderRadius: '20px', fontSize: '0.8rem', border: '1px solid #10b98144', fontWeight: '600' }}>
                          Core: Healthy
                       </div>
                       <div className="header-metric small text-secondary">
                          <Server size={14} className="me-1" style={{ color: '#00f2ff' }}/> Agents Online: <b className="text-white">{data.agents_online}</b>
                       </div>
                       <div className="header-metric small text-secondary">
                          <Wifi size={14} className="me-1" style={{ color: '#00f2ff' }}/> Uptime: <b className="text-white" style={{ color: '#00f2ff' }}>{data.uptime}</b>
                       </div>
                     </div>
                   </header>
        
        {data.ai_tokens_spent >= data.ai_tokens_limit && (
                  <div className="alert bg-danger bg-opacity-10 border-danger text-danger d-flex align-items-center gap-3 m-4 py-3 shadow-lg" 
                      style={{ borderRadius: '12px', border: '1px solid #ef4444', animation: 'fadeIn 0.5s ease-in-out' }}>
                    <ShieldAlert size={24} className="text-danger" />
                    <div className="flex-grow-1">
                      <div className="fw-bold" style={{ fontSize: '1rem' }}>ATTENTION! AI TOKENS EXPIRED</div>
                      <div className="small opacity-80">
                        Your current plan's AI analysis tokens have been fully consumed. 
                        Automated threat detection is now paused. Please 
                        <b className="text-decoration-underline ms-1 pointer" style={{cursor: 'pointer'}} onClick={() => navigate('/subscription')}>upgrade your plan</b> 
                        to resume AI monitoring or analyze logs manually.
                      </div>
                    </div>
                    <button className="btn btn-danger btn-sm fw-bold px-3" onClick={() => navigate('/subscription')}>
                      UPGRADE NOW
                    </button>
                  </div>
                )}


        <div className="p-4 p-lg-5">
          <div className="mb-5 text-center">
            <h1 className="fw-bold text-white mb-2">Start free. Scale as your infrastructure grows.</h1>
            <p className="text-secondary">SECURE LIGHTWEIGHT AGENTS. ZERO OVERHEAD. REAL-TIME LINUX MONITORING</p>
          </div>

          <div className="row g-4 justify-content-center">
            {plans.map(plan => {
               const isActive = data.plan_name === plan.id && data.subscription_status === 'active';
              return (
                <div className="col-xl-3 col-md-6" key={plan.id}>
                  <div className={`p-4 h-100 d-flex flex-column position-relative transition-all ${isActive ? 'border-info' : 'border-secondary'}`} 
                       style={{ 
                         background: '#0d1117', 
                         borderRadius: '4px', 
                         border: isActive ? '2px solid #00f2ff' : '1px solid #1e293b',
                         boxShadow: isActive ? '0 0 30px rgba(0, 242, 255, 0.1)' : 'none'
                       }}>
                    
                    {plan.tag && (
                      <div className="position-absolute" style={{ top: '15px', left: '15px' }}>
                        <span className="badge border border-info text-info bg-transparent" style={{ fontSize: '9px', letterSpacing: '1px' }}>{plan.tag}</span>
                      </div>
                    )}

                    <div className="mt-4 mb-2 d-flex align-items-center gap-3">
                      <h3 className="fw-bold m-0 text-white">{plan.name}</h3>
                    </div>
                    
                    <div className="mb-4">
                      <span className="display-5 fw-bold text-white">${plan.price}</span>
                      <span className="text-secondary ms-1">/month</span>
                    </div>

                    <ul className="list-unstyled flex-grow-1 mb-5">
                      {plan.features.map((feat, idx) => (
                        <li key={idx} className="d-flex align-items-start gap-2 mb-3 text-secondary small">
                          <Check size={16} className="text-info mt-1" style={{ minWidth: '16px' }} />
                          <span>{feat}</span>
                        </li>
                      ))}
                    </ul>

                    {isActive && billingInfo?.renew_date && (
                      <div className="text-center mb-3 animate-pulse">
                        <div className="fw-bold text-white" style={{ fontSize: '1.1rem' }}>
                          Will renew on <span className="text-info">{billingInfo.renew_date}</span>
                        </div>
                        <div className="text-secondary" style={{ fontSize: '0.7rem' }}>
                          {plan.id === 'FREE' ? 'Next free cycle' : 'Next billing cycle'}
                        </div>
                      </div>
                    )}


                    {isActive ? (
                      <div className="mt-auto">
                        <button disabled className="btn btn-info w-100 fw-bold py-2 mb-3 shadow-info uppercase" style={{ background: '#00f2ff', color: '#0b0e14', border: 'none' }}>
                          YOUR ACTIVE PLAN
                        </button>
                        {plan.id !== 'FREE' && (
                          <button 
                            onClick={handleCancelSubscription} 
                            disabled={loading}
                            className="btn btn-link text-danger w-100 small text-decoration-none d-flex align-items-center justify-content-center gap-2"
                          >
                            {loading ? <Loader2 size={14} className="animate-spin" /> : <XCircle size={14}/>} 
                            CANCEL SUBSCRIPTION
                          </button>
                        )}
                      </div>
                    ) : (
                      <button 
                        onClick={() => handlePlanChange(plan.id)}
                        disabled={loading}
                        className="btn btn-outline-secondary w-100 fw-bold py-2 mt-auto uppercase text-white border-secondary"
                        style={{ letterSpacing: '1px' }}
                      >
                        {loading ? <Loader2 size={16} className="animate-spin" /> : (plan.id === 'FREE' ? 'GET EARLY ACCESS' : `START ${plan.name}`)}
                      </button>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <style>{`
        .shadow-info { box-shadow: 0 0 20px rgba(0, 242, 255, 0.3); }
        .uppercase { text-transform: uppercase; }
        .animate-spin { animation: spin 2s linear infinite; }
        @keyframes spin { 100% { transform: rotate(360deg); } }
      `}</style>
    </div>
  );
};

export default SubscriptionPage;